import {useNavigation} from '@react-navigation/native';
import * as React from 'react';
import {CityChange} from '../../shared/components/menu/components/city/cityChange';
import Screen from '../../shared/components/screen';
import {CustomScrollView} from '../../shared/components/scrollView';
import {useStyles} from '../../shared/hooks/styles';

export const ChangeCityMobileScreen: React.FC = () => {
  const navigation = useNavigation();
  const styles = useStyles(() => ({
    container: {
      paddingTop: 25,
      paddingBottom: 35,
      paddingHorizontal: 35,
    },
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic' contentContainerStyle={styles.container}>
        <CityChange onClose={() => navigation.goBack()} />
      </CustomScrollView>
    </Screen>
  );
};
